import { createUseStyles } from 'react-jss';

import { FontWeight } from '../../../../styles';

const useStyles = createUseStyles(
  () => ({
    description: {
      textAlign: 'center',
      fontSize: '16px',
      fontWeight: FontWeight.SemiBold,
      color: 'var(--x-text-color-2)',
      maxWidth: '278px',
    },
    upload: {
      position: 'relative',
      display: 'inline-flex',

      '& > button': {},
      '& > input': {
        visibility: 'hidden',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
      },
    },
  }),
  {
    name: 'sticky-upload',
  },
);

export default useStyles;
